import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-textarea',
  templateUrl: './formly-textarea.component.html',
  styleUrls: [],
})
export class FormlyTextareaComponent extends FieldType {
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation()
    }
  }
}
